import { useConversationUrl } from '@hooks/use-conversation-url';
import { useAppSelector } from '@redux/hooks';
import RfqModal from '@tkmp/rfq/components/RfqModal/RfqModal';
import { useInlineRfqForm } from '@tkmp/rfq/hooks/useInlineRfqForm/useInlineRfqForm';
import { CtaButton } from '@tkww/orion-web-ds-action';
import React from 'react';

export const AboutCta = () => {
	const vendorId = useAppSelector((state) => state.vendor.vendor?.id);
	const conversationUrl = useConversationUrl(vendorId);

	const localFormContext = useInlineRfqForm({
		freeTextLabel:
			'Say hello and ask a question about style, budget or availability.',
		initiator: 'About CTA',
		headerText: 'Start the convo',
	});

	if (conversationUrl) {
		return (
			<CtaButton
				as="a"
				styleType={'secondary'}
				size="md"
				treatAs="link"
				href={conversationUrl}
				data-testid="about-cta-view-conversation"
			>
				View Conversation
			</CtaButton>
		);
	}

	return (
		<>
			<RfqModal context={localFormContext} />
			<CtaButton
				styleType={'secondary'}
				onClick={localFormContext.openModal}
				size="md"
				data-testid="about-cta-message-vendor"
			>
				Message Vendor
			</CtaButton>
		</>
	);
};
